function ResetKnifeButton() {
    const [updateTrigger, setUpdateTrigger] = React.useState(0);
    
    const resetAllSelections = () => {
        if (typeof window.KnifeCustomizationState === 'undefined') return;
        
        // Reset selection IDs
        window.KnifeCustomizationState.selectedShape = null;
        window.KnifeCustomizationState.selectedBlade = null;
        window.KnifeCustomizationState.selectedHandle = null;
        
        // Reset product data objects
        window.KnifeCustomizationState.selectedBladeData = null;
        window.KnifeCustomizationState.selectedHandleData = null;
        
        // Trigger React state updates via setters
        if (window.KnifeCustomizationState.setSelectedShape) {
            window.KnifeCustomizationState.setSelectedShape(null);
        }
        if (window.KnifeCustomizationState.setSelectedBlade) {
            window.KnifeCustomizationState.setSelectedBlade(null);
        }
        if (window.KnifeCustomizationState.setSelectedHandle) {
            window.KnifeCustomizationState.setSelectedHandle(null);
        }
        
        // Reset accordion state
        window.KnifeCustomizationState.activeAccordion = null;
        if (window.KnifeCustomizationState.setActiveAccordion) {
            window.KnifeCustomizationState.setActiveAccordion(null);
        }
        
        // Scroll to top
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        
        setUpdateTrigger(prev => prev + 1);
        console.log('All knife customizations reset, accordions collapsed, scrolled to top');
    };
    
    return React.createElement('div', {
        className: 'reset-button',
        onClick: resetAllSelections,
        style: { cursor: 'pointer' }
    },
        React.createElement('div', { className: 'reset--button-text' }, 'RESET KNIFE'),
        React.createElement('img', {
            src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d64cf53de35dba15bd1f53_9ca7e0fa65307fe51373378192d8b7ee_reset-icon.svg',
            loading: 'lazy',
            width: 'Auto',
            alt: '',
            className: 'reset--button-icon'
        })
    );
}

window.ResetKnifeButton = ResetKnifeButton;